import React from 'react';
import errorImage from "../resources/images/404.jpg";

const NoMatch = () => {
    return (
        <div>
            <img src={errorImage} alt="" />
        </div>
    )
}

export default NoMatch
